import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ResourcesService } from 'src/app/core/services/utils/resources/resources.service';
import { EventsAdmin } from 'src/app/core/models/events-admin/events-admin';
 
@Injectable({
  providedIn: "root",
})
export class EventsAdminService {
  private baseUrl =
    "https://int.api.transit-hub.thomsonreuters.com/webhooks-management";
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "Content-Type",
      "Access-Control-Allow-Credentials": "true",
    }),
 
    params: {},
  };
 
  private environmentRealms : any[] = [
    {
      location: "localhost",
      name: "gofileroom-ci",
      admin_access_only: false,
      id: 21
    },
    {
      location: "ci.gofileroom.com",
      name: "gofileroom-ci",
      admin_access_only: false,
      id: 21
    },
    {
      location: "demo.gofileroom.com",
      name: "gofileroom-demo",
      admin_access_only: false,
      id: 26
    },
    {
      location: "qed.gofileroom.com",
      name: "gofileroom-qed",
      admin_access_only: false,
      id: 24
    },
    {
      location: "ukqed.gofileroom.com",
      name: "gofileroom-ukqed",
      admin_access_only: false,
      id: 24
    }
  ];
 
  private eventsCache: any[] = [];
  private gfreventsCache: any[] = [];
  private channelsCache: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(
    []
  );
  private schemaCache: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  private productsCache: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(
    []
  );
  private realmId: any;
  private eventDetailsGFR =  new BehaviorSubject<any[]>([]);
  currentEventDetailsGFR = this.eventDetailsGFR.asObservable();


  constructor(private http: HttpClient, private resources: ResourcesService) {
    this.realmId = this.getRealmId();
  }
 
  updateEventDetailsGFR(eventDetailsGFR: any[]) {
    this.eventDetailsGFR.next(eventDetailsGFR);
  }

  getJwtToken(): Observable<any> {
    return this.http.get(
      environment.base_workflows_api_uri + "EventsAdmin/GetJWTToken"
    );
  }
 
  fetchEvents(): Observable<any> {
    const url = `${this.baseUrl}/realms/${this.realmId}/endpoints/internal`;
    return this.http.get(url).pipe(
      tap()
    );
  }
 
  getRealmId(): any {
    let location = document.location.hostname;
    let realm = this.environmentRealms.find(x => x.location === location);
    return realm.id;
  }
 
  getProductBasedOnEnvironment(): Observable<any>{
    let location = document.location.hostname;
    let realm = this.environmentRealms.find(x => x.location === location);
    return of(realm);
  }
 
  clearEventsCache(): void {
    this.eventsCache = [];
  }
 
  fetchChannels(): Observable<any[]> {
    const url = `${this.baseUrl}/realms/${this.realmId}/channels`;
    return this.http.get<any[]>(url) as Observable<any[]>;
  }
 
  fetchSchemas(channelId: number): Observable<any> {
 
    if (!isNaN(channelId)) {
      const url = `${this.baseUrl}/realms/${this.realmId}/channels/${channelId}/schemas`;
      return this.http.get<any[]>(url).pipe(
        tap()
      );
    }
    return of([]); // Return an empty observable if channelId is null
  }
 
  fetchProducts(): Observable<any> {
    if (this.productsCache.getValue().length > 0) {
      return this.productsCache.asObservable();
    }
    const url = `${this.baseUrl}/realms`;
    return this.http.get<any[]>(url).pipe(
      tap((productsdata) => {
        this.productsCache.next(productsdata);
      })
    );
  }
 
  removeEvent(eventId: string): Observable<any> {
    const url = `${this.baseUrl}/endpoints/${eventId}`;
    return this.http.delete(url).pipe(
      tap((resdata) => {
        this.eventsCache = this.eventsCache.filter(
          (event) => event.id !== eventId
        );
      })
    );
  }
 
  removeEventGFR(eventId: string): Observable<any> {
    const url = `${environment.base_workflows_api_uri}EventsAdmin/DeleteEventRegistration?eventId=${eventId}`;
    return this.http.delete(url).pipe(
      tap()
    );
  }
  getEvent(eventId: string): Observable<any> {
    const url = `${this.baseUrl}/endpoints/${eventId}`;
    return this.http
      .get(url)
      .pipe();
  }
 
  updateEvent(eventId: string, event: EventsAdmin): Observable<any> {
    const url = `${this.baseUrl}/endpoints/${eventId}`;
    var body = {
      channel_id: event.channel_id,
      name: event.name,
      product: event.product,
      url: encodeURI(event.url),
      endpoint_state: event.endpoint_state,
      distribution_attributes: event.distribution_attributes,
      ordering_enabled: event.ordering_enabled,
    };
    return this.http.put(url, body).pipe(
      tap()
    );
  }
 
  addEvent(event: EventsAdmin): Observable<any> {
    const url = `${this.baseUrl}/realms/${event.product}/channels/${event.channel_id}/endpoints/internal`;
    const body = {
      distribution_attributes: event.distribution_attributes,
      endpoint_state: event.endpoint_state,
      name: event.name,
      ordering_enabled: event.ordering_enabled,
      url: encodeURI(event.url),
      use_custom_certificate: "false",
      use_service_bus: "false",
    };
    return this.http.post(url, body).pipe(
      tap()
    );
  }
  addEventGFR(event: EventsAdmin): Observable<any> {
    const url = `${environment.base_workflows_api_uri}EventsAdmin/SaveEventRegistration`;
    const body = { 
      id:event.id,
      description: event.description,
      created_date: event.creationDate,
      schema_id: event.schemaId
    };
    return this.http.post(url, body).pipe(
      tap()
    );
  }
  updateEventGFR(event: EventsAdmin): Observable<any> {
    const url = `${environment.base_workflows_api_uri}EventsAdmin/UpdateEventRegistration`;
    const body = { 
      id:event.id,
      description: event.description,
      schema_id: event.schemaId
    };
    return this.http.post(url, body).pipe(
      tap()
    );
  }
  sendSchemaPayload(
    eventId: string,
    schemaName: string,
    payload: any
  ): Observable<any> {
    const url = `${this.baseUrl}/endpoint/${eventId}/test/${schemaName}`;
    return this.http.post(url, payload).pipe(
      tap()
    );
  }
  getEventDetailsGFR(): Observable<any> {
    return this.http.get(
      environment.base_workflows_api_uri + "EventsAdmin/GetEventsRegistrations"
    ).pipe(
      tap()
    );
  }
 
}